class HookContextError extends Error {
	name = 'HookContextError';

	constructor(hook: string, context?: string) {
		super(`${hook} must only be used from within ${context}`);
	}
}

export default HookContextError;
